// Browser-only tint: retain 55% of the active primary colour, mixed with black.
// This consumes the palette without changing any design-system brand tokens.
export const subduedColour = channels => '#' + Array.from(channels).slice(0, 3)
    .map(value => Math.round(value * 0.55).toString(16).padStart(2, '0')).join('');

export default function desktopBrowserTheme() {
    const meta = document.querySelector('[data-lds-desktop-theme]');
    if (!meta) return;
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d');
    if (!ctx) return; // Keep the server-rendered preset or charcoal fallback.
    const probe = document.createElement('span');
    probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;top:0;left:0';
    probe.setAttribute('aria-hidden', 'true');
    document.body.append(probe);
    const update = () => {
        probe.style.color = document.body.matches('.lds-brand-custom-local')
            ? 'var(--lds-ghost-brand-accent, var(--lds-custom-accent-colour, #202420))'
            : 'var(--lds-colour-brand-primary, #82a523)';
        ctx.clearRect(0, 0, 1, 1);
        ctx.fillStyle = getComputedStyle(probe).color;
        ctx.fillRect(0, 0, 1, 1);
        meta.content = subduedColour(ctx.getImageData(0, 0, 1, 1).data);
        const rootStyle = document.documentElement.style;
        if (rootStyle.getPropertyValue('--lds-desktop-browser-tint') !== meta.content) {
            rootStyle.setProperty('--lds-desktop-browser-tint', meta.content);
        }
    };
    update();
    // Honour palette changes in Ghost's design preview and code injection.
    const observer = new MutationObserver(update);
    [document.documentElement, document.body].forEach(element => observer.observe(element,
        {attributes: true, attributeFilter: ['class', 'style', 'data-landcare-brand']}));
    window.addEventListener('load', update, {once: true});
}
